import { RootState } from "../store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { rdsSelectionGet } from "../../utils/rds";
import { apiUrls } from "../../components/shared/apiUrls";
import { rdsSelection_RequestDto, rdsSelection_ResponseDto } from "../../interfaces/dtos/rdsSelection";
import { jsonToQueryString } from "../../utils/http";

export const loadRdsSelections = createAsyncThunk(
    'rds/loadRdsSelections',
    async (eventId: number, { getState }) => {

        const request: rdsSelection_RequestDto = {
            eventId
        };

        const response = await rdsSelectionGet<rdsSelection_ResponseDto>(
            `${apiUrls.rdsSelections.getAll}?${jsonToQueryString(request)}`
        );

        const { rds } = getState() as RootState;
        const otherSelections = rds.rdsSelections.filter((s) => s.eventId !== eventId);

        return [...otherSelections, ...response.data];
    }
);
